"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterForm = void 0;
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const boutik_gatsby_plugin_components_1 = require("@sbi-international/boutik.gatsby.plugin.components");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const customerAccountContext_1 = require("../../../contexts/customerAccountContext");
const constants_1 = require("../../../constants");
const Button_1 = require("../../common/Button");
const feedbackContext_1 = require("../../../contexts/feedbackContext");
const NewsletterForm = () => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const { addAlert } = (0, react_1.useContext)(feedbackContext_1.FeedbackContext);
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const currentUser = customerAccountContext.currentUser;
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const [formGlobalErrorMessage, setFormGlobalErrorMessage] = (0, react_1.useState)();
    const methods = (0, react_hook_form_1.useForm)({
        defaultValues: {
            is_subscribed: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSubscribed,
        },
    });
    const updateNewsletterSubscription = (formData) => {
        setFormGlobalErrorMessage(undefined);
        return customerAccountContext.actions.informations
            .updateCustomer({ is_subscribed: formData.is_subscribed })
            .then(() => {
            addAlert({
                message: t("global.success.editNewsletterSubscription"),
                status: "success",
            });
        })
            .catch((error) => {
            setFormGlobalErrorMessage(t(boutik_gatsby_plugin_components_1.FormInput.FormValidation.getMagentoErrorTranslationKey(currentLocale, error.message)));
        });
    };
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
        react_1.default.createElement("form", { onSubmit: methods.handleSubmit(updateNewsletterSubscription), className: "boutik-customer-account-uai-nf-container" },
            react_1.default.createElement("h1", { className: "boutik-customer-account-uai-nf-title" }, t("customerAccount.updateAccountInformation.newsletter.title")),
            react_1.default.createElement("p", { className: "boutik-customer-account-uai-nf-global-error-message" }, formGlobalErrorMessage),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "boutik-customer-account-uai-nf-state" }, t((currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSubscribed)
                    ? "customerAccount.updateAccountInformation.newsletter.state.subscribed"
                    : "customerAccount.updateAccountInformation.newsletter.state.unsubscribed")),
                react_1.default.createElement("input", Object.assign({ className: "boutik-customer-account-uai-nf-input", type: "checkbox" }, methods.register("is_subscribed"))),
                react_1.default.createElement("label", { className: "boutik-customer-account-uai-nf-label" }, t("customerAccount.updateAccountInformation.newsletter.subscribe"))),
            react_1.default.createElement(Button_1.Button, { isLoading: methods.formState.isSubmitting, classNamePrefix: "boutik-customer-account-uai-nf-save", label: "global.button.save", isSubmitButton: true }))));
};
exports.NewsletterForm = NewsletterForm;
//# sourceMappingURL=NewsletterForm.js.map